import { apiService } from './api';
import { Permission, UserRole, RoleDetail, CreateRoleRequest, UpdateRoleRequest, PaginationParams } from '../types';

const ROLES_API = '/roles';
const PERMISSIONS_API = '/permissions';

export const roleService = {
  getRoles: (params?: PaginationParams) =>
    apiService.get<UserRole[]>(ROLES_API, {
      pageNumber: params?.pageNumber ?? 1,
      pageSize: params?.pageSize ?? 100,
    }),

  getRoleById: (id: number | string) =>
    apiService.get<RoleDetail>(`${ROLES_API}/${id}`),

  createRole: (data: CreateRoleRequest) =>
    apiService.post<UserRole>(ROLES_API, data),

  updateRole: (id: number | string, data: UpdateRoleRequest) =>
    apiService.put<UserRole>(`${ROLES_API}/${id}`, data),

  deleteRole: (id: number | string) =>
    apiService.delete<boolean>(`${ROLES_API}/${id}`),

  getPermissions: () =>
    apiService.get<Permission[]>(PERMISSIONS_API),
};
